import { baseService } from "service/base";

class IncidentDetailReportService {
  loadByToken(jwtToken) {
    const data = {
      jwtToken,
    };

    return baseService.post("/api/report/incident-detail/", data);
  }
}

const incidentDetailReportService = new IncidentDetailReportService();

export { incidentDetailReportService };
